// src/App.tsx - COMPLETE UPDATED FILE
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import Login from './pages/Login';

// Layout Components
import AdminLayout from './layouts/AdminLayout';
import AspirantLayout from './layouts/Aspirantlayout';
import CitizenLayout from './layouts/CitizenLayout';

// Admin Pages
import AdminDashboard from './pages/AdminDashboard';
import AdminAspirants from './pages/AspirantDashboard';
import AdminReports from './components/AdminReport';
import AdminCampaigns from './components/AdminCampaigns';

// Aspirant Pages
import AspirantDashboard from './pages/AspirantDashboard';
import Memorandums from './pages/Memorandums';
import SmsCampaigns from './pages/SmsCampaigns';
import Reports from './pages/Report';
import AspirantReports from './pages/AspirantsReports';
import HeatMap from './pages/HeatMap';
import Manifesto from './pages/Manifesto'; // Import the new Manifesto page

// Citizen Pages
import CitizenDashboard from './pages/CitizenDashboard';
import CitizenProfile from './pages/CitizenProfile';
import CitizenReportNew from './pages/CitizenReportNew';
import CitizenReports from './pages/CitizenReports';
import CitizenReportDetail from './pages/CitizenReportDetail'; // IMPORTANT: Add this import
import Community from './pages/Community';
import CitizenAspirantProfile from './pages/CitizenAspirantProfile';

// Shared Pages
import Settings from './pages/Settings';

// Components
import { CreateCampaignModal } from './components/CreateCampaignModal';

function App() {
  const [showCreateCampaign, setShowCreateCampaign] = React.useState(false);

  useEffect(() => {
    const handleCreateMemorandum = (event: CustomEvent) => {
      const { type, aspirantId } = event.detail;
      console.log('Creating memorandum:', type, aspirantId);
    };

    window.addEventListener('create-memorandum', handleCreateMemorandum as EventListener);
    
    return () => {
      window.removeEventListener('create-memorandum', handleCreateMemorandum as EventListener);
    };
  }, []);

  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={
            <ProtectedRoute allowedRoles={['ADMIN', 'STAFF']}>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="aspirants" element={<AdminAspirants />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="campaigns" element={<AdminCampaigns />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Aspirant Routes */}
          <Route path="/aspirant" element={
            <ProtectedRoute allowedRoles={['ASPIRANT']}>
              <AspirantLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AspirantDashboard />} />
            <Route path="memorandums" element={<Memorandums />} />
            <Route path="campaigns" element={<SmsCampaigns />} />
            <Route path="reports" element={<AspirantReports />} />
            <Route path="all-reports" element={<Reports />} />
            <Route path="heatmap" element={<HeatMap />} />
            <Route path="manifesto" element={<Manifesto />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Citizen Routes */}
          <Route path="/citizen" element={
            <ProtectedRoute allowedRoles={['CITIZEN']}>
              <CitizenLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<CitizenDashboard />} />
            <Route path="reports" element={<CitizenReports />} />
            {/* IMPORTANT: Add the report detail route - this must come AFTER the reports route */}
            <Route path="reports/:reportId" element={<CitizenReportDetail />} />
            <Route path="profile" element={<CitizenProfile />} />
            <Route path="report/new" element={<CitizenReportNew />} />
            <Route path="community" element={<Community />} />
            <Route path="aspirant/:aspirantId" element={<CitizenAspirantProfile />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Default Redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>

        {/* Global Create Campaign Modal */}
        {showCreateCampaign && (
          <CreateCampaignModal 
            onClose={() => setShowCreateCampaign(false)}
            onSuccess={() => {
              window.dispatchEvent(new Event('campaign-created'));
            }}
          />
        )}
      </AuthProvider>
    </Router>
  );
}

export default App;